import Vue from 'vue';

export default (context, interval) => {
  if(!context.airbnbLastCheckAirlock || (new Date()).getTime() - context.airbnbLastCheckAirlock > 5000) {
    context.airbnbLastCheckAirlock = (new Date()).getTime();
    const username = context.abAccount.airbnbUsername.replace("+", "%2B");
    return Vue.$http.get('/airlock/status?username=' + username).then((response) => {
      if(response.data.status == 1 && !context.abAccount.afterAirlock) {
          context.airbnbActiveStep = 1;
          context.abAccount.afterAirlock = true;
          context.airbnbConnectUpdate();
          clearInterval(interval);
      }
    })
  }
};



// WEBPACK FOOTER //
// ./src/app/services/airbnb/waitingAirlockVerification.js